import React from 'react'
import {MBMemberRadio} from '../../../Atoms/MBMemberRadio'
import {Line} from '../../../Atoms/Line'
import {ContractTerm} from '../../../../Props/ContractInputInfo'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'

export type LabelAndValue = {
  label: string
  value: ContractTerm
}

type Props = {
  name: string
  labelAndValues: LabelAndValue[]
  selectedValue?: string
  hasError: boolean
  onChange: (value: ContractTerm) => void
}

export const MBMemberRadioListForContractTerm: React.VFC<Props> = (props) => {
  return (
    <PIMStack spacing={'10px'}>
      {
        props.labelAndValues.map((labelAndValue, i) => {
          return <Line key={i}>
            <MBMemberRadio
              name={props.name}
              labelName={labelAndValue.label}
              checked={props.selectedValue === labelAndValue.value}
              hasError={props.hasError}
              onChange={(): void => {
                props.onChange(labelAndValue.value)
              }}
            />
          </Line>
        })
      }
    </PIMStack>
  )
}
